module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "activation-container"
  }, [(_vm.active) ? _c('h1', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (!_vm.active) ? _c('h1', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Deactivated")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tDisactivated\n\t\t\t\t\t"), _c('md-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.active),
      expression: "active"
    }],
    attrs: {
      "md-theme": "green",
      "id": "my-test5",
      "name": "my-test5"
    },
    domProps: {
      "value": (_vm.active)
    },
    on: {
      "change": _vm.onActivate,
      "input": function($event) {
        _vm.active = $event
      }
    }
  }), _vm._v("\n\t\t\t\t\tActivated\n\t\t")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b08adc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activation.vue
// module id = 100
// module chunks = 2